//import Libraries
import React, { Component } from 'react';
import {connect} from 'react-redux';
//import Components
import {Row, Col, FormGroup, Label, Input} from 'reactstrap'
import EditConfirmButton from '../../Components/EditConfirmButton/EditConfirmButton';

import * as homepageActions from '../actions/homepageActions';

//import Styles
import './History.css';

class History extends Component {

    constructor(props) {
        const { year, month, content } = props.history;
        super(props);
        this.state = {
            year,
            month : month ? month : '',  
            koContent : content['ko'],
            enContent : content['en'],
        }
    }

    //  componentDidUpdate(prevProps, prevState, snapshow) {
        // if(prevProps.history.year !== this.props.history.year || 
        //    prevProps.history.month !== this.props.history.month || 
        //    prevProps.history.content['en'] !== this.props.history.content['en'] ||
        //    prevProps.history.content['ko'] !== this.props.history.content['ko']) {
        //     this.setState({
        //         year : this.props.history.year,
        //         month : this.props.history.month,
        //         kocontent : this.props.history.content['ko'],
        //         encontent : this.props.history.content['en'],
        //     })
        // }
    //  }

    handleOnChange = (e) => {
        this.setState({
            [e.target.name] : e.target.value
        })
    }

    toggleEditing = () => {
        const { id, year, content, month } = this.props.history;
        this.props.askCancleEditing(() => {
            this.props.toggleEditing(id);
            this.setState({
                year,
                month : month ? month : '',
                kocontent : content['ko'],
                encontent : content['en'],
            })
        }, id)
    }

    render() {
        const { year, month, koContent, enContent } = this.state;
        const { editing } = this.props;

        const renderEditing = (
            <Row>
                <Col xs={2}>
                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                        <Label className="mr-sm-2">년도</Label>
                        <Input
                            type="number" name="year"
                            value={this.state.year} onChange={this.handleOnChange}
                            disabled={!editing}
                            min={1980} max={2030}
                            bsSize="sm"
                        />
                    </FormGroup>
                </Col>
                <Col xs={2}>
                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                        <Label className="mr-sm-2">달</Label>
                        <Input
                            type="number" name="month"
                            value={this.state.month} onChange={this.handleOnChange}
                            disabled={!editing}
                            min={1} max={12}
                            bsSize="sm"
                        />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup className="mb-8 mr-sm-8 mb-sm-0">
                        <Label className="mr-sm-2">내용</Label>
                        <Input
                            type="textarea" name="koContent"
                            value={koContent} onChange={this.handleOnChange}
                            disabled={!editing}
                            bsSize="sm"
                        />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup className="mb-8 mr-sm-8 mb-sm-0">
                        <Label className="mr-sm-2">Content</Label>
                        <Input
                            type="textarea" name="enContent"
                            value={enContent} onChange={this.handleOnChange}
                            disabled={!editing}
                            bsSize="sm"
                        />
                    </FormGroup>
                </Col>
                <Col sm={1}>
                    <EditConfirmButton
                        editing={this.props.editing}
                        onConfirm={() => this.props.onUpdateHistory({
                            id: this.props.history.id,
                            year,
                            month,
                            content: {
                                'en': enContent,
                                'ko': koContent
                            },
                            year,
                        })}
                        onRemove={() => this.props.onRemoveHistory(this.props.history.id)}
                        onToggleEditing={this.toggleEditing}
                    />
                </Col>
            </Row>
        );
        const renderNotEditing = (
            <Row>
                <Col xs={2}>
                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                        <Label className="mr-sm-2">년도</Label>
                        <p> {this.props.history.year} </p> </FormGroup>
                </Col>
                <Col xs={2}>
                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                        <Label className="mr-sm-2">달</Label>
                            <p> { this.props.history.month && this.props.history.month } </p>
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup className="mb-8 mr-sm-8 mb-sm-0">
                        <Label className="mr-sm-2">내용</Label>
                        <p> {this.props.history.content['ko']} </p>
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup className="mb-8 mr-sm-8 mb-sm-0">
                        <Label className="mr-sm-2">Content</Label>
                        <p> {this.props.history.content['en']} </p>
                    </FormGroup>
                </Col>
                <Col sm={1}>
                    <EditConfirmButton
                        editing={this.props.editing}
                        onConfirm={() => this.props.onUpdateHistory({
                            id: this.props.history.id,
                            year,
                            month,
                            content: {
                                'en': enContent,
                                'ko': koContent
                            },
                            year,
                        })}
                        onRemove={() => this.props.onRemoveHistory(this.props.history.id)}
                        onToggleEditing={this.toggleEditing}
                    />
                </Col>
            </Row>

        );

        return (
            <div className="sub-category">
            <div className="IndexLabel">{this.props.index + 1}</div>
            {
                editing ? renderEditing : renderNotEditing
            }
            </div>
        );
    }
}

export const mapDispatchToProps = (dispatch) => {
    return {
        onUpdateHistory  : (data) => {
            dispatch(homepageActions.updateHistory(data));
        },
        onRemoveHistory : (id) => {
            dispatch(homepageActions.removeHistory(id));
        }
    }
}

export default connect(null, mapDispatchToProps)(History);


// WEBPACK FOOTER //
// ./src/pages/Admin/HomepageManager/HistoryManager/History.js